<div [ngClass]="getClasses('abc-popup-dialog')">
  @if (settings.showHeader) {
    <section [ngClass]="getClasses('abc-popup-dialog-header-section')">
      @if (settings.headerSVGIcon) {
        <abc-icon [ngClass]="getClasses('abc-popup-dialog-header-icon')" [svgIcon]="settings.headerSVGIcon"></abc-icon>
      }
      @if (settings.headerTitle) {
        <p [ngClass]="getClasses('abc-popup-dialog-header-title')">
          {{ settings.headerTitle }}
        </p>
      }
    </section>
  }

  @if (settings.showContent) {
    <section [ngClass]="getClasses('abc-popup-dialog-content-section')">
      @if (settings.htmlMessage) {
        <p [ngClass]="getClasses('abc-popup-dialog-content-htmlMessage')" [innerHTML]="settings.htmlMessage"></p>
      }
      @if (settings.shortMessage) {
        <p [ngClass]="getClasses('abc-popup-dialog-content-shortMessage')">
          {{ settings.shortMessage }}
        </p>
      }
      @if (settings.longMessage) {
        <pre [ngClass]="getClasses('abc-popup-dialog-content-longMessage')">
          {{ settings.longMessage }}
        </pre>
      }
    </section>
  }
</div>
